import script from "./NavigationBarMember3.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBarMember3.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBarMember3.vue?vue&type=style&index=0&id=a667ab48&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a667ab48"]])

export default __exports__